import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

@InputType()
export class LinkChatRequesterArgs extends ActionArgs {
  @Field(() => ID)
  chatId: string

  @Field(() => ID)
  requesterId: string
}

export interface ILinkChatRequester extends IAction<Chat, LinkChatRequesterArgs> {}
